/**
 * Returns true if the role has country_settings (role-based flow).
 * Use with data from GET /roles - pass the roles array.
 */
export const isRoleBasedTesterRole = (roleId, roles = []) => {
  const role = Array.isArray(roles)
    ? roles.find((r) => Number(r.id) === Number(roleId))
    : null;
  return role ? (Number(role.country_count) || 0) > 0 : false;
};
